import Constants from "@/constants";

export const EVENT_MAP = {
  /** 全局下拉刷新触发事件 */
  LAYOUT__PULL_TO_REFRESH: "LAYOUT__PULL_TO_REFRESH",
} as const;

type TMapKey = keyof typeof EVENT_MAP;
type ListenKey = TMapKey extends never ? string | number : TMapKey;
type ListenMap = Record<ListenKey, Function[]>;

export class EventListener {
  constructor(private container = Object.create(null) as ListenMap) {
    this.container = container;
  }
  public on(key: ListenKey | ListenKey[], fn: Function) {
    const keys = Array.isArray(key) ? key : [key];
    keys.forEach(k => {
      (this.container[k] || (this.container[k] = [])).push(fn);
    });
    return () => this.off(key, fn);
  }
  public off(key: ListenKey | ListenKey[], fn: Function) {
    const keys = Array.isArray(key) ? key : [key];
    keys.forEach(k => {
      const listener = this.container[k] || [];
      ~listener.indexOf(fn) && listener.splice(listener.indexOf(fn), 1);
    });
  }
  public emit(key: ListenKey, ...args: any[]) {
    (this.container[key] || []).forEach(fn => fn(...args));
  }
  public once(key: ListenKey, fn: Function) {
    const onceWrapper = (...args: any[]) => {
      fn.apply(this, args);
      this.off(key, onceWrapper);
    };
    return this.on(key, onceWrapper);
  }
  public removeAll(key?: ListenKey) {
    // @ts-ignore
    key ? delete this.container[key] : (this.container = Object.create(null));
  }
}

export const event = new EventListener();
export default event;

if (Constants.IS_DEBUG || Constants.IS_USEDEBUG) {
  (window as any).__event = event;
  (window as any).__EVENT_MAP = EVENT_MAP;
}
